import fromPairs from 'lodash/fromPairs';
import round from 'lodash/round';
import sum from 'lodash/sum';
import sumBy from 'lodash/sumBy';

import { budgets } from '../../campaign-editor/constants';

export function getSpentBudgetValue(campaign) {
  return (
    // The totalSpentBudget field is only available in basic campaigns.
    // For normal campaigns it needs to be calculated from productMetas -
    // this would be too expensive in the backend.
    campaign.totalSpentBudget || sumBy(campaign.productMetas, 'spend') || 0
  );
}

export function getOpenBudget(campaigns) {
  const openBudgets = campaigns
    .filter(campaign => campaign.status !== 'Ended')
    .map(campaign => campaign.spendableBudget - getSpentBudgetValue(campaign));
  return sum(openBudgets);
}

export function getNetClientBudget(campaigns) {
  const netClientBudgetValues = campaigns
    .filter(campaign => campaign.status !== 'Ended')
    .map(campaign => campaign.netClientBudget);
  return sum(netClientBudgetValues);
}

export function getNetClientBudgetExternal(campaigns) {
  const netClientBudgetValues = campaigns
    .filter(campaign => campaign.status !== 'Ended')
    .map(campaign => campaign.netClientBudgetExternal);
  return sum(netClientBudgetValues);
}

export function getWkzBudget(campaigns) {
  const netClientBudgetValues = campaigns
    .filter(campaign => campaign.status !== 'Ended')
    .map(campaign => campaign.wkzBudget);
  return sum(netClientBudgetValues);
}

export function getCoInvest(campaigns) {
  const coInvestValues = campaigns
    .filter(campaign => campaign.status !== 'Ended')
    .map(campaign => campaign.coInvest);
  return sum(coInvestValues);
}

export function getFreeService(campaigns) {
  const freeServiceValues = campaigns
    .filter(campaign => campaign.status !== 'Ended')
    .map(campaign => campaign.freeService);
  return sum(freeServiceValues);
}

export function getSpendableBudget(campaigns) {
  const values = campaigns
    .filter(campaign => campaign.status !== 'Ended')
    .map(campaign => campaign.spendableBudget);
  return sum(values);
}

export function getBusinessBudgets(campaign) {
  return fromPairs(
    budgets.map(({ business }) => {
      const relevantCampaignLines = campaign.campaignLines.filter(
        line => line.product.business === business,
      );
      const budget = sumBy(relevantCampaignLines, 'spendableBudget');
      return [business, budget && round(budget, 2)];
    }),
  );
}

// This only works as long as every product that has a spent is also present in
// a campaign line.
export function getBusinessSpents(campaign) {
  const productBusinesses = {};
  campaign.campaignLines.forEach(cl => {
    productBusinesses[cl.product.id] = cl.product.business;
  });

  const spentBudgets = fromPairs(budgets.map(({ business }) => [business, 0]));
  campaign.productMetas.forEach(({ productId, spend }) => {
    const business = productBusinesses[productId];
    spentBudgets[business] += spend;
  });
  return spentBudgets;
}
